import { useFormik } from "formik";
import { useState } from "react";
// import { auth, createUserProfileDocument } from '../../../Firebase/utils';
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import { ReactComponent as CloseButton } from "../../../assets/images/closeX.svg";
import { ReactComponent as EyeSvg } from "../../../assets/images/eye.svg";
import { ReactComponent as HideSvg } from "../../../assets/images/hide.svg";
import { ReactComponent as LoaderSpinner } from "../../../assets/images/loader.svg";
import { closeSignupModalFunc } from '../../../redux/Modal/modal.actions';
import { signupUser } from "../../../redux/User/user.actions";
import {
  FieldWrapper,
  Form,
  FormInput,
  FormSubText,
  FormTitle,
  InputLabel,
  SubmitButton,
  Wrapper
} from "./style";

const validationSchema = Yup.object().shape({
  hostelName: Yup.string().required("Hostel name is required"),
  hostelAddress: Yup.string().required("Hostel address is required"),
  email: Yup.string()
    .email("Please provide a valid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password cannot be empty"),
});
function SignUpForm({ hideFunc }) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [hidePassword, setHidePassword] = useState(true);
  const history = useHistory();

  const handlePasswordToggle = () => {
    setHidePassword((prev) => !prev);
  };

  const handleFormSubmit = async (values) => {

    setIsLoading(true);
    await dispatch(signupUser(values, history));
    await setIsLoading(false);
    history.push('/host-events');
  }
  const formik = useFormik({
    initialValues: {
      hostelName: "",
      hostelAddress: "",
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: handleFormSubmit,
  });

  const { values, errors, handleChange, handleSubmit, touched } = formik;
  return (
    <Wrapper>
      <Form onSubmit={handleSubmit}>
        <FormTitle>Create a Hostel Account</FormTitle>
        <FormSubText>
          {" "}
          If you are not a hostel, <small>sign up here</small>
        </FormSubText>
        <FieldWrapper>
          <InputLabel htmlFor="#hostelName">Hostel name</InputLabel>
          <FormInput
            onChange={handleChange("hostelName")}
            value={values.hostelName}
            name="hostelName"
            id="hostelName"
            placeholder={"No Fixed Address"}
          />
          {errors.hostelName && touched.hostelName && (
            <small className="error">{errors.hostelName}</small>
          )}
        </FieldWrapper>
        <FieldWrapper>
          <InputLabel htmlFor="#hostelAddress">Hostel Address</InputLabel>
          <FormInput
            onChange={handleChange("hostelAddress")}
            value={values.hostelAddress}
            name="hostelAddress"
            id="hostelAddress"
            placeholder={"12345 No Address, Nowhere, Somewhere 00000"}
          />
          {errors.hostelAddress && touched.hostelAddress && (
            <small className="error">{errors.hostelAddress}</small>
          )}
        </FieldWrapper>
        <FieldWrapper>
          <InputLabel htmlFor="#email">Email</InputLabel>
          <FormInput
            onChange={handleChange("email")}
            value={values.email}
            name="email"
            id="email"
            placeholder={"livefreely@nofixedaddresses.com"}
          />
          {errors.email && touched.email && (
            <small className="error">{errors.email}</small>
          )}
        </FieldWrapper>
        <FieldWrapper>
          <InputLabel htmlFor="#password">Password</InputLabel>
          <div className="input_wrapper">
            <FormInput
              onChange={handleChange("password")}
              value={values.password}
              name="password"
              id="password"
              type={hidePassword ? "password" : "text"}
              placeholder={"Password"}
            />
            {hidePassword ? (
              <EyeSvg onClick={handlePasswordToggle} />
            ) : (
              <HideSvg onClick={handlePasswordToggle} />
            )}
          </div>

          {errors.password && touched.password && (
            <small className="error">{errors.password}</small>
          )}
        </FieldWrapper>
        <SubmitButton type="submit" disabled={isLoading ? true : false}>
          {isLoading ? <LoaderSpinner /> : "Create Account"}
        </SubmitButton>
        <p className="sign_in_link_text">
          Already have an account?<br></br>
          <span>Sign in.</span>
        </p>
      </Form>
      <CloseButton onClick={() => dispatch(closeSignupModalFunc())} className="close-btn" />
    </Wrapper>
  );
}

export default SignUpForm
